import { useMutation } from '@tanstack/react-query';
import { pushNotificationsApi, BroadcastPayload, BroadcastResult } from '../api/push-notifications.api';
import toast from 'react-hot-toast';

export function useBroadcastNotification() {
  return useMutation<BroadcastResult, Error, BroadcastPayload>({
    mutationFn: pushNotificationsApi.broadcast,
    onSuccess: (data) => {
      const fcmMsg =
        data.fcm.success > 0
          ? `FCM: ${data.fcm.success} delivered`
          : 'FCM: 0 delivered (no tokens registered)';
      toast.success(`Notification sent! ${fcmMsg} · In-app: ${data.inApp}`);
    },
    onError: (err) => {
      toast.error(err.message ?? 'Failed to send notification');
    },
  });
}
